// extracted by mini-css-extract-plugin
export var hideEditor = "_gq-2";
export var infoIcon = "_gq-3";
export var label = "_gq-1";
export var labelContainer = "_gq-0";
export var readonlyText = "_gq-4";